module.exports = __webpack_public_path__ + "static/media/facebook.9858fd95.svg";